import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import BootstrapTable, { SortOrder, TableChangeState, TableChangeType } from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { ApplicationState } from "../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect, useSelector } from "react-redux";
import {
  addDataPeriod,
  deleteDataPeriod,
  deleteDataPeriodRequest,
  getDataPeriods,
  getUpdatedAreaOfNeed,
  hideManageDataPeriodsModal,
  updateDataPeriod,
} from "../../../../../../store/onboarding/actions";
import { DataPeriod, EvidencePeriodData, ReactSelectOption } from "../../../../../../store/onboarding/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faPlus,
  faPlusCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import LoadingIndicator from "../../../../../common/onboarding/LoadingIndicator";
import Select from "react-select";
import {
  getTimePeriodLabel,
  getTimePeriodWithoutLabel,
  TimePeriodOptions,
} from "../../../../../../store/groups/types";
import { toastr } from "react-redux-toastr";
import CoachDataPeriodSelector from "../../../CoachDataPeriodSelector";
import useUserRole from "../../../../../../utils/hooks/useUserRole";
import App from "../../../../../../App";
import { useDispatch } from "react-redux";
import { showConfirmDialog } from "../../../../../../store/confirm-dialog/actions";
import _ from "lodash";

type StateProps = {
  dataPeriods: Array<DataPeriod>;
  isLoading: {
    getDataPeriods: boolean;
    addDataPeriod: boolean;
    updateDataPeriod: boolean;
    deleteDataPeriod: boolean;
  };
  showModal: boolean;
  selectedEvidencePeriodData?: EvidencePeriodData; 
};

type DispatchProps = {
  hideManageDataPeriodsModal: () => any;
  addDataPeriod: (dataPeriod: Partial<DataPeriod>) => any;
  updateDataPeriod: (
    dataPeriodId: number,
    dataPeriod: Partial<DataPeriod>
  ) => any;
  deleteDataPeriod: (dataPeriodId: number) => any;
  getUpdatedAreaOfNeed: (dataPeriodId: number, isBehavior: boolean) => any;
};

type Props = StateProps & DispatchProps;

const ManageDataPeriodsModal: FunctionComponent<Props> = ({
  dataPeriods,
  showModal,
  isLoading,
  selectedEvidencePeriodData,
  addDataPeriod,
  updateDataPeriod,
  deleteDataPeriod,
  hideManageDataPeriodsModal
}) => {
  const { isDistrictOwner,isTeacher,isCoach } = useUserRole();
  const [sortedDataPeriod, setSortedDataPeriod] = useState<DataPeriod[]>([]);
  const [sortField, setSortField] = useState<string | undefined>(undefined);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | undefined>(undefined);
  const defaultDataPeriod: Partial<DataPeriod> = useMemo(
    () => ({
      id: 0,
      year: "",
      time_period: undefined,
      name: "",
    }),
    []
  );

  const permissionSetting = useSelector(
    (s:ApplicationState) => s.auth.userInfo
  );

  const permissionMessage = useMemo(()=>{
    let permissionMsg;
    if(!permissionSetting?.settings_present) {
      permissionMsg = 'You do not have any permissions set. Please contact your district administrator.';
    } else if(permissionSetting?.block_access_to_all_data) {
      permissionMsg = 'You do not have access to data. Please contact your district administrator.';
    }
    return permissionMsg;
  },[permissionSetting])

  const [updatedDataPeriod, setUpdatedDataPeriod] = useState<any | undefined>(
    undefined
  );
  const [displayLoaderId, setDisplayLoader] = useState<any>(0);

  const date = new Date();
    const currentYear = date.getFullYear();

    const possibleYears: ReactSelectOption<string>[] = [];
    for (let i = -5; i < 5; ++i) {
      possibleYears.push({
        value: (currentYear + i).toString(),
        label: (currentYear + i).toString(),
      });
    }

  const hideModalShow = () => {
    setUpdatedDataPeriod(undefined);
  };

  // const selectedDataPeriod = useSelector(
  //   (s: ApplicationState) => s.onboarding.currentDataPeriod
  // );

  const dispatch = useDispatch();

  // const caretRenderer = (order: SortOrder | undefined, column: any) => {
  //   const style = { fontWeight: 'bold', fontSize: '1.2rem', marginLeft: '4px' };

  //   if (order === 'asc') return <span style={style}>&uarr;</span>;
  //   if (order === 'desc') return <span style={style}>&darr;</span>;
  //   return null;
  // }

  const columns = useMemo(
    () => [
      {
        dataField: 'name',
        text: 'Data Period Name',
        sort: true,
      },
      {
        dataField: 'time_period',
        text: 'Time Period',
        sort: true,
      },  
      {
        headerStyle: { width: "25%", "text-align": "center" },
        dataField: "actions",
        style: {
          textAlign: "center" as any,
        },
        text: !isTeacher ? 'Actions' : ''
      },
    ],
    []
  );

  const options = useMemo(
    () => ({
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
      ],
    }),
    []
  );

  // const defaultSorted: [{ dataField: string; order: SortOrder }] = useMemo(
  //   () => [
  //     {
  //       dataField: "name",
  //       order: "asc",
  //     },
  //   ],
  //   []
  // );

  const myId = useSelector<ApplicationState, number | undefined>(
    (s) => s.auth.userInfo?.id
  );
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
  const handleDeleteDataPeriod = (dataPeriodId: number) => {
    dispatch(
      showConfirmDialog({
        onConfirm: () => {
          setDisplayLoader(dataPeriodId);
          return deleteDataPeriod(dataPeriodId).then(
            () => {
              setUpdatedDataPeriod(undefined);
              toastr.success(
                "Success",
                "The data period has been successfully deleted!"
              );
              setDisplayLoader(0);
              dispatch(getDataPeriods());
            },
            (err: string) => {
              setDisplayLoader(0);
              toastr.error("Failed to delete the data period", err)
            }
          )

        },
        centered: true,
        title: "Delete Data Period",
        text: (
          <>
            <p className="text-center font-weight-bold">Are you sure you want to delete this data period?</p>
            <p className="text-center">This data period may be shared with other users who might have used it. If you proceed, they could lose access.</p>
          </>
        ),
        confirmButtonText: "Delete",
      })
    );
  };
  useEffect(() => {
    const originalData = _.cloneDeep(dataPeriods);
    const sortedData = [...originalData];
    sortedData.sort((a, b) => {
      let aValue: any;
      let bValue: any;
  
      switch (sortField) {
        case "name":
          aValue = `${a.name}`.trim();
          bValue = `${b.name}`.trim();
          break;
        case "time_period":
          aValue = `${a.time_period}`.trim();
          bValue = `${b.time_period}`.trim();
          break;
        default:
          return 0;
      }
      const isEmpty = (val: any) => val === null || val === undefined || val === 'N/A';
        
      if (isEmpty(aValue) && !isEmpty(bValue)) return 1;
      if (!isEmpty(aValue) && isEmpty(bValue)) return -1;
      if (isEmpty(aValue) && isEmpty(bValue)) return 0;
      
      aValue = aValue.toString().trim();
      bValue = bValue.toString().trim();
  
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortOrder === "asc"
          ? collator.compare(aValue, bValue)
          : collator.compare(bValue, aValue);
      }
      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    });
    setSortedDataPeriod(sortedData);
    const classListDesc = (document.getElementsByClassName('caret-4-desc') as HTMLCollectionOf<HTMLElement>)?.[0];
    const classListAsc = (document.getElementsByClassName('caret-4-asc') as HTMLCollectionOf<HTMLElement>)?.[0];
    if(sortOrder === 'asc') { 
      if(classListAsc){
        classListAsc.style.display = 'inline-block';
      }
    } else if (sortOrder === 'desc') {
      if(classListDesc){
        classListDesc.style.display = 'inline-block';
      }
    } else if(!sortField && !sortOrder) {
      if(classListAsc){
        classListAsc.style.display = 'none';
      }
      setSortField(undefined);
      setSortOrder(undefined);
    }
  }, [dataPeriods, isTeacher, isCoach, myId, isLoading, sortField, sortOrder]);

  const noDataIndicator = useMemo(() => {
    if (!sortedDataPeriod.length && isLoading.getDataPeriods) {
      return <LoadingIndicator type="table" rows={5} columns={3} />;
    }
    return "No data";
  }, [isLoading.getDataPeriods, sortedDataPeriod]);

  const handleDatePeriodSave = (e: any) => {
    e.preventDefault();
    if (updatedDataPeriod.id) {
      updateDataPeriod(updatedDataPeriod.id, updatedDataPeriod).then(
        () => {
          setUpdatedDataPeriod(undefined);
          const isBehavior = selectedEvidencePeriodData?.evidence_column_groups?.[0].is_behaviour_primary_screening!;
          dispatch(getUpdatedAreaOfNeed(updatedDataPeriod.id, isBehavior));
          toastr.success(
            "Success",
            "The data period has been successfully updated!"
          );
          dispatch(getDataPeriods());
        },
        (err: string) => toastr.error("Failed to update the data period", err)
      );
    } else {
      addDataPeriod(updatedDataPeriod).then(
        () => {
          setUpdatedDataPeriod(undefined);
          toastr.success(
            "Success",
            "The data period has been successfully added!"
          );
          dispatch(getDataPeriods());
        },
        (err: string) => toastr.error("Failed", err)
      );
    }
  };

  const firstUpdate = useRef(true);

  useEffect(() => {
    if(updatedDataPeriod && updatedDataPeriod.year && updatedDataPeriod.time_period) {
      if(firstUpdate.current){
        setUpdatedDataPeriod((dataPeriod: any) => ({     
          ...dataPeriod,
          name: (updatedDataPeriod?.id == 0) ? `${updatedDataPeriod.year} - ${getTimePeriodWithoutLabel(updatedDataPeriod.time_period)}`: updatedDataPeriod.name,
        }))
        firstUpdate.current = false;
        return;
      }
    }
  },[updatedDataPeriod])

  // const message = useMemo(() => {
  //   return selectedDataPeriod
  //       ? "You can create, update, and delete data periods."
  //         : dataPeriods.length
  //           ? "You do not have the selected data period. You can create a new data period or select an existing one."
  //             : "You have no data period. First create a new one.";
  // }, [selectedDataPeriod, dataPeriods.length]);

  const isYearExist =  updatedDataPeriod && (updatedDataPeriod.year !== '') && possibleYears.some((y) => y.value === updatedDataPeriod.year)
  
  const handleTableChange = (type: TableChangeType, { sortField: clickedField }: TableChangeState<any>) => {
    if (type === 'sort') {
      let newSortField: string | undefined = clickedField;
      let newSortOrder: 'asc' | 'desc' | undefined = 'asc';
  
      if (sortField === clickedField) {
        if (sortOrder === 'asc') {
          newSortOrder = 'desc';
        } else if (sortOrder === 'desc') {
          // Third click → Clear the sort
          newSortField = undefined;
          newSortOrder = undefined;
        }
      }
  
      setSortField(newSortField);
      setSortOrder(newSortOrder);
    }
  };
  return (
    <>
      <Modal
        show={showModal}
        size={"lg"}
        onShow={hideModalShow}
        onHide={hideManageDataPeriodsModal}
        backdropClassName={`customDarkModalBackdrop in`}
        centered
      >
        <Modal.Header closeButton className="purpleModalHeader">
          <Modal.Title>{!isTeacher ? 'Manage' : 'Your'} Data Periods</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {permissionMessage ?
              <tr>
                <td colSpan={2} className="font-weight-bold">{permissionMessage}</td>
              </tr>
          :
          <>

            {!isTeacher 
              ? <div className="row justify-content-between align-items-end mx-0 py-2">
                  <div className="col px-0">
                    <h4 className="font-weight-bold mb-3">You can create, update, and delete data periods.</h4>
                    <span className="alert alert-warning py-1 px-1"><strong>Note:</strong> You can update or delete only the data periods you created.</span>
                  </div>
                  {/* <div className="col-auto px-0"> */}
                    <button
                      className="blueBtnSm withInnerWhiteSvg"
                      onClick={ async () => {
                        await setUpdatedDataPeriod(undefined); 
                        setUpdatedDataPeriod(defaultDataPeriod)
                      } }
                    >
                      <FontAwesomeIcon icon={faPlusCircle}/>
                      Create
                    </button>
                  {/* </div> */}
                  
              </div>

              : 
                <div className="py-2">
                  <h4 className="font-weight-bold mb-3">You can view the data periods assigned to you.</h4>
                  <span className="alert alert-warning py-1 px-1"><strong>Note:</strong> If you need a data period created, updated, or deleted, please contact your District Admin or Coach.</span>
                </div>
            }

            {/* {!selectedDataPeriod && !!dataPeriods.length && (
              <div className="mb-3">
                <CoachDataPeriodSelector small />
              </div>
            )} */}

            
            <BootstrapTable
              remote={{ sort: true }}
              classes="rosterTable"
              keyField="id"
              bordered={false}
              bootstrap4
              data={
                sortedDataPeriod.map((dataPeriod) => {
                  const isMyDataPeriod = myId === dataPeriod.user_id;
                  return {
                    id: dataPeriod.id,
                    name: `${dataPeriod.name}${isMyDataPeriod ? "" : ` (Shared by ${
                      dataPeriod.user_name ? dataPeriod.user_name : dataPeriod.user_email
                    })`}`,
                    time_period: getTimePeriodLabel(dataPeriod.time_period),
                    actions:
                      !isMyDataPeriod && !isCoach ? null : (
                        <div>
                          {!isMyDataPeriod && isCoach ? (
                            <span className="ml-3"></span>
                          ) : (
                            <span onClick={() => setUpdatedDataPeriod(dataPeriod)}>
                              <FontAwesomeIcon icon={faPen} size="lg" />
                            </span>
                          )}

                          {dataPeriods.length > 1 ? (
                            !isMyDataPeriod && isCoach ? (
                              <span className="ml-3"></span>
                            ) :
                            (displayLoaderId != dataPeriod.id) ? <span
                              onClick={(e: any) => {
                                e.stopPropagation();
                                handleDeleteDataPeriod(dataPeriod.id);
                              }}
                              // style={{
                              //   visibility: isLoading.deleteDataPeriod ? "hidden" : "visible",
                              // }}
                              className="ml-4"
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                size="lg"
                                style={{ color: "red" }}
                              />
                            </span>
                            :
                            <span className="ml-1"><Spinner animation="border" size="sm" /></span>
                          ) : (
                            ""
                          )}
                        </div>
                      ),
                  };
                })
              }
              columns={columns}
              pagination={dataPeriods.length > 10 ? paginationFactory(options) : undefined}
              noDataIndication={noDataIndicator}
              onTableChange={handleTableChange}
              sort={sortField && sortOrder ? {
                dataField: sortField,
                order: sortOrder,
              } : undefined } 
            />
          </>
        }
        </Modal.Body>
      </Modal>
      {updatedDataPeriod 
      ? 
        <Modal
          show={updatedDataPeriod}
          size={"lg"}
          onHide={() => setUpdatedDataPeriod(undefined)}
          centered
          backdropClassName={`customDarkModalBackdrop inner in`}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="purpleModalHeader">
            <Modal.Title>{updatedDataPeriod?.id
                      ? "Update Existing Data Period"
                      : "Create New Data Period"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="overflow-inherit">
            <Form>
              <Row>
                <Col md={3}>
                  <h4 className="font-weight-bold m-0">Year</h4>
                  <Select
                    value={possibleYears.find((y) => y.value === updatedDataPeriod.year)}
                    menuPlacement="auto"
                    options={possibleYears}
                    placeholder="Select"
                    // components={{
                    //   DropdownIndicator: () => null,
                    //   IndicatorSeparator: () => null,
                    // }}
                    styles={{
                      menuPortal: (styles) => ({ ...styles, zIndex: 100 }),
                    }}
                    openMenuOnFocus
                    onChange={(year: any) => {
                      setUpdatedDataPeriod((dataPeriod: any) => ({
                        ...dataPeriod,
                        year: year.value,
                      }));
                      firstUpdate.current = true;
                    }}
                    isDisabled={updatedDataPeriod.id}
                  />
                </Col>
                <Col md={4}>
                  <h4 className="font-weight-bold">Time Period</h4>
                  <Select
                    placeholder={"Select"}
                    //isClearable
                    value={TimePeriodOptions.find(
                      (tpo) => tpo.value === updatedDataPeriod.time_period
                    )}
                    options={TimePeriodOptions}
                    onChange={(timePeriodOption: any) => {
                      if(timePeriodOption) {
                        setUpdatedDataPeriod((dataPeriod: any) => ({
                          ...dataPeriod,
                          time_period: timePeriodOption.value,
                        }));
                      }
                      firstUpdate.current = true;
                    }}
                  />
                </Col>
                <Col md={5}>
                  <FormGroup controlId="dataPeriodName">
                    <FormLabel>
                      <h4 className="font-weight-bold">Data Period Name</h4>
                    </FormLabel>
                    <FormControl
                      autoFocus
                      className="fullWidthInput"
                      name={"dataPeriodName"}
                      placeholder="Suggested Name"
                      type="text"
                      value={updatedDataPeriod.name}
                      onChange={(e: React.FormEvent<any>) => {
                        e.preventDefault();
                        const { value } = e.target as HTMLInputElement;
                        setUpdatedDataPeriod((dataPeriod: any) => ({
                          ...dataPeriod,
                          name: value,
                        }));
                      }}
                      required
                    />
                  </FormGroup>
                </Col>
                
              </Row>
              <hr />        
              <div className="btnActions">
                <button className="whiteBtnSm" onClick={() => hideModalShow()}>Cancel</button>
                <button
                  className="blueBtnSm ml-2"
                  type="submit"
                  onClick={handleDatePeriodSave}
                  disabled={!isYearExist || (updatedDataPeriod.year == '') || (updatedDataPeriod.time_period == undefined) || (updatedDataPeriod.name == '')}
                >
                  {updatedDataPeriod?.id
                    ? "Update"
                    : "Create"}
                  {(isLoading.addDataPeriod || isLoading.updateDataPeriod) && (
                    <Spinner animation="border" size="sm" className="ml-1" />
                  )}
                </button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      : ''}
    </>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): StateProps => {
   return {
    dataPeriods: onboarding.dataPeriods,
    isLoading: {
      getDataPeriods: onboarding.isLoading.getDataPeriods,
      addDataPeriod: onboarding.isLoading.addDataPeriod,
      updateDataPeriod: onboarding.isLoading.updateDataPeriod,
      deleteDataPeriod: onboarding.isLoading.deleteDataPeriod,
    },
    showModal: onboarding.modalsState.manageDataPeriodsModal,
    selectedEvidencePeriodData: onboarding.evidencePeriodData,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      hideManageDataPeriodsModal: hideManageDataPeriodsModal,
      addDataPeriod: addDataPeriod,
      updateDataPeriod: updateDataPeriod,
      deleteDataPeriod: deleteDataPeriod,
      getUpdatedAreaOfNeed: getUpdatedAreaOfNeed,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageDataPeriodsModal);
